import {ListItemActionBar} from '@github-ui/list-view/ListItemActionBar'
import {ActionList} from '@primer/react'

import type {Project} from './types'

interface ProjectRowActionMenuProps {
  project: Project
  /**
   * Fired when the viewer selects "Remove project". Owned by a stable parent
   * (`ProjectList`) so its `onError` toast still runs after the row optimistically
   * unmounts — TanStack Query skips per-call `mutate` options bound to an
   * unmounted component.
   */
  onUnlinkProject: (project: Project) => void
}

/**
 * Kebab action menu for a single project row in the repo projects index. Mirrors
 * the repo-context branch of `Memex::ProjectList::ActionMenuComponent`. Only renders
 * the items the viewer can actually use; today that's just "Remove project". Make a
 * copy / Copy as template are deferred (see github/issues#21359).
 *
 * No confirmation dialog: the Rails view's form submits directly with no `confirm`
 * data attribute, and we mirror that here.
 *
 * Presentational only: the actual mutation call is owned by `ProjectList`.
 */
export function ProjectRowActionMenu({project, onUnlinkProject}: ProjectRowActionMenuProps) {
  return (
    <ListItemActionBar
      label={`Actions for ${project.title}`}
      staticMenuActions={[
        {
          key: 'remove',
          render: () => (
            <ActionList.Item variant="danger" onSelect={() => onUnlinkProject(project)}>
              Remove project
            </ActionList.Item>
          ),
        },
      ]}
    />
  )
}
